import React, { useEffect } from 'react';

interface LightThemeWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that forces light theme for public pages like landing page
 * This ensures consistent theming regardless of user's previous theme preference
 */
const LightThemeWrapper: React.FC<LightThemeWrapperProps> = ({ children }) => {
  useEffect(() => {
    const root = window.document.documentElement;
    
    // Force light theme on document root immediately
    root.classList.remove('dark');
    root.classList.add('light');
    
    // Cleanup function to restore original theme when component unmounts
    return () => {
      const currentTheme = localStorage.getItem('theme') || 'light';
      root.classList.remove('light', 'dark');
      root.classList.add(currentTheme);
    };
  }, []);

  // Also force light theme immediately on mount (before useEffect runs)
  React.useLayoutEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
  }, []);

  return <div className="light force-light-theme">{children}</div>;
};

export default LightThemeWrapper;